import { Client, Environment } from 'vivaa-api';

// re-export the namespaces from vivaa-api, for access to types
export * from 'vivaa-api';

const env: Environment =
  document.location.hostname === 'localhost' || document.location.hostname === '127.0.0.1'
    ? Environment.Weblocal
    : Environment.Webprod;
export const client = new Client(env);
